// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const RewardsPointsStyles = css`
  &.place-perks-account-header {
    padding: 0 ${(props) => props.theme.spacing.ELEM_SPACING.LRG}
      ${(props) => props.theme.spacing.ELEM_SPACING.LRG}
      ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
  }
  .place-perks-container {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    font-size: ${(props) => props.theme.typography.fontSizes.fs14};
    display: flex;
  }

  .place-perks-progress-bar {
    margin: ${(props) => props.theme.spacing.ELEM_SPACING.LRG} 13px 20px 0;
  }

  .place-perks-text-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .perk-level {
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-weight: ${(props) => props.theme.typography.fontWeights.bold};
    text-transform: uppercase;
  }
`;

export default RewardsPointsStyles;
